import React from "react";

import SearchImage from "../images/Search.png";

const QuarterSummaryCard = ({
  quarterSummary,
  loading = false,
  error = false,
  errorMessage = "",
}) => {
  if (loading) {
    return (
      <div className="card-section">
        <h3 className="card-section__title">Merchant Category</h3>
        {[...Array(4)].map((_, index) => (
          <div className="detail-item" key={index}>
            <div className="skeleton skeleton-text skeleton-text--small"></div>
            <div className="skeleton skeleton-text skeleton-text--medium"></div>
          </div>
        ))}
      </div>
    );
  }

  if (error) {
    return (
      <div className="card-section">
        <h3 className="card-section__title">Merchant Category</h3>
        <div className="error-state">
          <img src={SearchImage} alt="Error" className="error-image" />
          <h4 className="error-title">Error Fetching Data</h4>
          <p className="error-message">{errorMessage}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="card-section">
      <h3 className="card-section__title">Merchant Category</h3>
      {quarterSummary.map((item) =>
        Object.keys(item).map((key) => (
          <div className="detail-item" key={key}>
            <span className="label">{key}</span>
            <span className="value text-right-align">{item[key] || "N/A"}</span>
          </div>
        ))
      )}
    </div>
  );
};

export default QuarterSummaryCard;
